<template>
  <div class="p-warp">
    <div v-for="(item,index) in caseList" :key="index">
      <div v-if="index == type">
        <p class='p-title'>{{item.title}}</p>
        <div class="p-img">
          <img src="./../../../assets/boao/downL.gif" alt="">
        </div>
        <div class="p-tip">
          <span>图片来源：博鳌亚洲论坛</span>
          <span>发布时间：2019-06-11 17:23:29</span>
          <span>浏览次数：765</span>
        </div>
        <img class="p-content-img" :src="item.image" alt="">
        <div class="p-content">{{content}}<br/><br/>{{content1}}<br/><br/>{{item.content2}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      content:'6月10日，博鳌亚洲论坛秘书长、外交部原副部长李保东先生出席博鳌亚洲论坛全球健康论坛大会博览会开幕式。李保东秘书长表示，发起成立全球健康论坛并举办此次大会，旨在搭建一个在全球具有广泛代表性和权威性的政商学结合、高端对话与务实合作的综合性平台，促进全球健康事业和健康产业的发展。',
      content1:'此次大会分论坛一汇聚了世界卫生组织、全球医生组织、国内医疗监管部门、全国排名靠前医院、医疗信息建设行业主要企业等单位的代表，紧扣「创新促进健康——互联网医疗的未来」分论坛主题，就互联网医疗的现状、未来发展前景、存在问题、解决措施、5G重大影响等方面进行了充分探讨，并提出了众多政策建议。',
      caseList:[
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E8%B5%B5%E6%9D%B0.jpeg',
          title:'赵杰：「5G智慧医疗服务：机遇与挑战」',
          content2:'中国卫生信息学会远程医疗信息化专委会主任委员赵杰先生分别从5G在智慧医疗服务中的支撑、应用和探索三大方面依次展开阐述， 并对从国家工程实验室到国家远程医疗中心、中国信通院、标委会实现三位一体全面合作充满信心。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E5%8D%A2%E6%B8%85%E5%90%9B.jpeg',
          title:'卢清君：「互联网+医疗依法执业的新业态」',
          content2:'国家卫生健康委员会远程医疗管理与培训中心办公室主任卢清君先生报告了远程医疗协同网络建设的发展历程，同时强调目前面临政策研究、医疗协同、技术创新、示范推广的四大主要任务。对国家远程医疗与互联网医学中心三大运营体系进行深入解析，并期待引入新技术，把大数据、云计算、人工智能真正转化到临床，最终实现大数据协助国家卫生健康作出重大决策支撑。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E6%88%B4%E5%BF%A0.jpeg',
          title:'戴忠：「互联网+医疗和健康医疗大数据的探索与实践」',
          content2:'中国移动通信集团有限公司政企客户分公司总经理戴忠先生阐述了中国移动从“互联网医疗”、“智慧医院”、“大数据与人工智能”等方面助力中国战略、服务医改和百姓健康的重大举措。强调快速推动5G网络在健康医疗服务创新发展、助力远程医疗快速覆盖等方面的重要作用。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E6%97%B6%E5%8D%A0%E8%AF%A6.jpeg',
          title:'时占祥：「探讨互联网+医疗健康：是先加医疗，还是先加健康？」',
          content2:'全球医生组织中国总代表、NIH 临床研究中心中国项目负责人时占祥博士对“互联网+医疗健康”实施方式进行了深入地探索和思考。他表示，中国已经建立了全球最大的高速公路网、全球最大规模的高速铁路网，已有全球最多用户的互联网宽带+无线通信网，即将建设的全球最大“远程医健网”将成为第四大网。通过“远程医健网”的逐步落地，提高国民健康素养，让医疗服务从平等走向自由选择。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E7%94%B0%E6%87%8B%E4%B8%80.jpeg',
          title:'田懋一：「数字健康作为加强我国医疗体系的工具」',
          content2:'世界卫生组织代表，乔治全球健康研究院（中国）高级研究员田懋一先生针对移动医疗干预目前主要用于慢病和非传染性疾病提出自己的看法，他认为移动健康对于解决卫生服务的公平性非常重要，移动医疗在卫生体系的方面所起的作用还有待进一步完善。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E5%BC%A0%E4%BC%9F.jpeg',
          title:'张伟：「信息化时代的未来医疗发展趋势」',
          content2:'四川大学华西医院党委书记张伟先生认为面对公立医院需要的改革，科技革命的变革，国家政策一定会随之更新。由新技术革命带来的支撑，未来医学发展将分为终身健康管理、临床医学、慢病管理和养老服务四个部分。在未来，智慧康养和临终关怀均可通过感应器和穿戴设备居家实现。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E9%83%91%E5%BE%B7%E5%AF%8C.jpeg',
          title:'郑德富：「地级市医院基于远程医疗的医联体建设经验报告」',
          content2:'江西省上饶市人民医院医务处处长、远程会诊中心主任郑德富先生具体介绍了医联体建设的过程及进展，并对目前取得的主要成效加以说明。同时，郑德富先生对实施过程中遇到的远程医疗报销无法进医保等问题进行了阐述。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E8%A2%81%E7%8E%89%E5%B9%B3.jpeg',
          title:'袁玉平：「远程医疗，一个复杂多方协同样本的探索」',
          content2:'中卫佰医的联合创始人袁玉平先生从远程医疗运营当中遇到的主要障碍入手，详细讲解了如何解决这些问题。重点关注社会管理协调问题，认为远程医疗本质上是一个涉及患者、下级医生、下级医院、上级医院、上级医生、服务平台、监管部门共七方的复杂协同，协同流程的冗长、协同动机的弱化，都将导致协同无法发生。中卫佰医给出了建立病例链接系统、医生协作系统、财务实时分发系统、强监管后台管理系统四大系统改变传统会诊的具体解决方案，以应对远程医疗运营过程中遇到的种种问题，也为《焦点访谈》中提到远程会诊网利用率不到20%交上了满意答卷。'
        },
        {
          image:'https://cdn2019.oss-cn-beijing.aliyuncs.com/webStatic/guanwang/%E9%9F%A9%E5%AE%8F%E5%9D%A4.jpeg',
          title:'韩宏坤：「医疗大数据·数据治理·未来医学大脑」',
          content2:'迪斯杰（北京）数据管理有限公司董事长兼总裁韩宏坤先生认为医疗大数据将对患者看病难的问题产生非常积极的作用。让医疗资源更合理地配对，患者更方便地找到专业、标准的医疗信息。未来通过数控平台数据交互，一定会构建出中国的医疗大脑 。'
        },
      ],
      type:''
    }
  },
  mounted(){
    this.type = this.$router.history.current.query.type -2
  }
}
</script>

<style lang="less" scoped>
.p-warp{
  width:1000px;
  margin:0 auto;
}
.p-title{
  font-size:24px;
  color:#333;
  text-align:center;
}
.p-img{
  text-align:center;
  margin:36px 0 26px 0;
}
.p-tip{
  text-align:center;
  font-size:14px;
  color:#666;
  margin-bottom:10px;
  span{
    padding-right:10px;
  }
}
.p-content-img{
  display:block;
  width:638px;
  height:426px;
  margin:0 auto;
}
.p-content{
  margin:46px auto 140px;
  width:646px;
  font-size:14px;
  color:#333;
  line-height:24px;
  letter-spacing: 1px;
}
</style>